import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')

		switch (type) {
			case 'banner':
				config = {
					loop: true,
					speed: 750,
					slidesPerView: 1,
					autoplay: true,
					modules: [Autoplay]
				}
			break;
			default:
			break;
		}

		const swiper = new Swiper(slider, {...config })

	})
}

export default () => {}
